import { MainHeader, type MainHeaderProps } from "@/toggle-ui-kit/main-header";
import { useIsMobile } from "@/styles/hooks/use-mobile";
import { getPageLabel } from "@/utils/document-title";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * 앱 페이지용 상단 바. 시각은 ui-kit MainHeader, 여기는 배선만:
 * 페이지 이름은 라우트(document.title 과 같은 표)에서, 로고는 홈으로.
 */
export const AppMainHeader = ({
  title,
  sidebar,
  onLogoClick,
  ...props
}: Omit<MainHeaderProps, "title"> & {
  /** 라우트 표에 없는 페이지만 직접 준다 */
  title?: string;
  /** 홈 이동 전에 가로채야 하는 페이지만 준다 (예: 미저장 변경 확인). 이동도 직접 한다 */
  onLogoClick?: () => void;
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // shadcn 사이드바는 768px 미만에서 Sheet 경로로 바뀌어 데스크톱 open 상태와 무관해진다.
  // 같은 breakpoint 훅으로 판단해 그때는 토글을 비활성화한다 — 배치는 흔들리지 않게 (이 앱은 데스크톱 전용).
  const isMobile = useIsMobile();

  const resolvedTitle = title ?? getPageLabel(pathname);
  if (resolvedTitle === null) {
    // 배선 실수(라우트 표 누락)는 빈 제목으로 조용히 넘기지 않는다
    throw new Error(
      `AppMainHeader: '${pathname}' 은 PAGE_TITLE_BY_PATH 에 없다. title 을 직접 주거나 utils/document-title 표에 추가하라.`,
    );
  }

  return (
    <MainHeader
      title={resolvedTitle}
      onLogoClick={onLogoClick ?? (() => navigate("/"))}
      sidebar={
        sidebar && { ...sidebar, disabled: sidebar.disabled || isMobile }
      }
      {...props}
    />
  );
};
